export const mapSingleAddressData = address => {
  const { streetNumber, streetName, zipcode, city, meterData } = address
  const label = (streetNumber ?? '') + ' ' + (streetName ?? '') + ' ' + (zipcode ?? '') + ' ' + (city ?? '')

  const electricityMeter = meterData?.electricityMeter
    ? {
        id: meterData.electricityMeter.id,
        pdlNo: meterData.electricityMeter.pdlNo,
        meterSerialNumber: meterData.electricityMeter.meterSerialNumber,
        pdlEligibilityData: meterData.electricityMeter.pdlEligibilityData,
        oldOccupant: meterData.electricityMeter.oldOccupant,
        validationWarnings: meterData.electricityMeter.validationWarnings || {},
        isValidPdl: !!meterData.electricityMeter.pdlNo,
        enedisAuth: meterData.electricityMeter.consentDate !== null,
        consentDate: meterData.electricityMeter.consentDate,
      }
    : {}

  const gasMeter = meterData?.gasMeter
    ? {
        id: meterData.gasMeter.id,
        pceNo: meterData.gasMeter.pceNo,
        meterSerialNumber: meterData.gasMeter.meterSerialNumber,
        pceEligibilityData: meterData.gasMeter.pceEligibilityData,
        isValidPce: meterData.gasMeter.isValidPce || !!meterData.gasMeter.pceNo,
        validationWarnings: meterData.gasMeter.validationWarnings || {},
        meterConsent: meterData.gasMeter.consentDate !== null,
        consentDate: meterData.gasMeter.consentDate,
      }
    : {}

  return {
    label: label.trim(),
    ...address,
    energyLandscape: address.energyLandscape ?? {},
    buildingPermitData: address.buildingPermitData ?? {},
    lastHolderData: address.lastHolderData ?? {},
    cadastralData: address.cadastralData ?? {},
    electricityMeter,
    gasMeter,
    hasElectricityMeter: meterData?.hasElectricityMeter || false,
    hasGasMeter: meterData?.hasGasMeter || false,
  }
}
